import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders, readFeatureFlags } from './feature-flags.loaders';

export const featureFlagsKeys = queryKeyFactory('feature-flags');

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: featureFlagsKeys.all,
    queryFn: () => loaders.getFeatureFlags(),
    placeholderData: readFeatureFlags,
  });
};
